import React from 'react';
import InputField from '../../../components/CustomFields/InputField';

const EducationDetails = ({ student, handleChange }) => {
    return (
        <section className="">
            <h2 className="text-lg font-semibold text-[#824296] text-center">Previous Education Details</h2>
            {student.educationDetails?.map((edu, idx) => (
                <div key={idx} className="space-y-4">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                        {/* School Name */}
                        <InputField
                            id={`schoolName-${idx}`}
                            label="School Name *"
                            value={edu.schoolName}
                            onChange={(e) => handleChange(`educationDetails[${idx}].schoolName`, e.target.value)}
                        />

                        {/* Degree */}
                        <InputField
                            id={`degree-${idx}`}
                            label="Degree *"
                            value={edu.degree}
                            onChange={(e) => handleChange(`educationDetails[${idx}].degree`, e.target.value)}
                        />
                    </div>
                </div>
            ))}
        </section>
    );
};

export default EducationDetails;